import React, { createContext, useState, useContext, useCallback } from 'react';

const ToastContext = createContext();

// 客戶要求：所有提醒（含 success / info / warning / error）一律不自動關閉，
// 由使用者點 X 自行關閉。原因是多則提醒同時跳出時，自動關閉會讓使用者來不及看完。
// 即使呼叫端傳入 duration 也會被忽略，避免個別頁面意外恢復自動關閉行為。

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
  }, []);

  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  // duration 參數保留供 API 相容，但一律強制為 0（不自動關閉）
  // eslint-disable-next-line no-unused-vars
  const showToast = useCallback((message, type = 'success', duration) => {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast = { id, message, type, duration: 0 };
    setToasts(currentToasts => [...currentToasts, newToast]);
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, showToast, removeToast, clearAllToasts }}>
      {children}
    </ToastContext.Provider>
  );
};

// 創建一個簡易的 Hook 來使用 Toast Context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
